// A press the browser took back (`pointercancel`: a system gesture, a palm, the pointer lost; the review of
// 2026-10-10). It ends like nothing happened: every draft the press started is dropped and NOTHING is sent — no fog
// box revealed, no zone painted, no grid line committed, no token moved, no selection replaced. The release (`onUp`)
// is the only place a press commits.
import { fogTool } from './fogTool';
import { zoneTool } from './zoneTool';
import { gridEditor } from './gridEditor';

/** The parts of the board's scene a press can leave a draft in. */
export interface PressDrafts {
  fogging: boolean;
  zoning: boolean;
  dragging: unknown;
  blankBox?: unknown;
  box: unknown;
  focusDrag: unknown;
  measureDrag: boolean;
  notMine: unknown;
  overlay: { clear(): unknown };
}

export interface CancelHooks {
  /** The token drag's own undo: the token (and its group) back where it stood, nothing sent. */
  cancelDrag(): void;
  /** The focus layer redrawn without the box. */
  redrawFocuses(): void;
}

export function cancelPress(scene: PressDrafts, hooks: CancelHooks): void {
  scene.measureDrag = false;
  scene.notMine = null;
  if (scene.fogging) fogTool.cancel();
  if (scene.zoning) zoneTool.cancel();
  if (scene.focusDrag) { scene.focusDrag = null; hooks.redrawFocuses(); }
  if (scene.dragging) {
    // A grid line under the hand: its draft goes, and the board draws the store's grid again (the editor's listener).
    scene.dragging = null;
    if (gridEditor.get().draft) gridEditor.draft(null);
  }
  hooks.cancelDrag();
  if (scene.blankBox) { scene.blankBox = null; scene.overlay.clear(); }
  if (scene.box) { scene.box = null; scene.overlay.clear(); }
}
